import {ExperienceResource} from '@/common/api/api-raw-types';
import {Experience} from '../../../domain/experience/Experience';

export function toExperience(resource: ExperienceResource): Experience {
    return {
        id: resource.id,
        title: resource.title,
        company: resource.company,
        companyId: resource.companyId,
        location: resource.location,
        organizationName: resource.organizationName,
        area: resource.area,
        description: resource.description,
        asFreelancer: resource.asFreelance,
        isCurrentJob: resource.currentJob,
        startDate: new Date(resource.startDate),
        endDate: new Date(resource.endDate),
        // tags: resource.tags,
    };
}
